// extracted by mini-css-extract-plugin
module.exports = {"linkStyle":"ReadMoreLink_linkStyle__3IKZs"};